import {
    Message
} from '../types';
import {Group} from "@mantine/core";
import {TagRecordButton} from "../../tags/buttons/TagRecordButton.tsx";
import {showSuccessNotification} from "../../../components/ServiceNotifications.tsx";
import {useNavigate} from "react-router-dom";


export const MessageToolbar = (
    {
        record
    }: {
        record: Message
    }
) => {


    const navigate = useNavigate();


    return (
        <Group my={"xl"} justify="center" gap={'sm'}>
            <TagRecordButton
                disabled={false}
                record={record}
                handleConfirm={() => {
                    showSuccessNotification();
                    navigate(`/messages/${record.id}`);
                }}/>

        </Group>
    );

};
